import { exportFullFileUrl, exportSearchResultsUrl, } from '@/constants/api'
import {
  SET_FILTERS,
  SET_PAGE_NUMBER,
  CHANGE_TABLE_LOADING,
  CREATE_OBJECT_OF_ID,
  PARSE_DATA,
  SHOW_RESULTS,
  SHOW_SEARCH_ERROR,
  TOGGLE_EXPORT_MODAL,
} from './mutations-types'
import { getData, createDownloadLink, } from '../../helpers'

// Helper function for error handling
const getResponseErrorMessage = (error) => {
  if (!error || !error.response) {
    return {
      message: 'Unable to connect to the server. Please check your internet connection.',
      body: null,
    }
  }

  // Check for JSON API format via headers
  const contentType = error.response.headers && (error.response.headers['content-type'] || error.response.headers['Content-Type'] || '')

  if (contentType.includes('application/vnd.api+json')) {
    // Check if the response has errors
    if (error.response.data && error.response.data.errors && Array.isArray(error.response.data.errors)) {
      // Check if errors have detail attributes
      if (error.response.data.errors.some((e) => e && e.detail)) {
        return {
          message: 'Request failed with errors',
          body: error.response.data,
        }
      }
      // Check if errors have title attributes
      else if (error.response.data.errors.some((e) => e && e.title)) {
        return {
          message: 'Request failed with errors',
          body: error.response.data,
        }
      }
    }
  }

  const truncateResponseData = (data, maxLength = 200) => {

    if (typeof data === 'object' || Array.isArray(data)) {
      return data
    }

    const strData = String(data)

    return (strData.length <= maxLength) ? strData : strData.substring(0, maxLength) + '... (truncated)'
  }

  // Fallback to generic error messages based on status code
  switch (error.response.status) {
  case 404:
    return {
      message: 'The requested resource could not be found.',
      body: {
        ...error.response,
        data: truncateResponseData(error.response.data),
      },
    }
  case 429:
    return {
      message: 'Rate limit exceeded. Please try again later.',
      body: {
        ...error.response,
        data: truncateResponseData(error.response.data),
      },
    }
  case 500:
    return {
      message: 'The server is currently unavailable. Please try again later.',
      body: {
        ...error.response,
        data: truncateResponseData(error.response.data),
      },
    }
  default:
    return {
      message: `An error occurred (${error.response.status}). Please try again.`,
      body: {
        ...error.response,
        data: truncateResponseData(error.response.data),
      },
    }
  }
}

export default {
  searchWithParams ({ commit, state, getters, dispatch, }) {
    commit(CHANGE_TABLE_LOADING, true)
    commit(SHOW_SEARCH_ERROR, false)
    return getData({ state, }, {
      params: getters.searchParams,
      cb: (data) => {
        commit(PARSE_DATA, data)
        commit(SHOW_RESULTS, true)
        commit(CREATE_OBJECT_OF_ID, state.items)

        if (state.currentPage > state.lastPage) {
          commit(SET_PAGE_NUMBER, state.lastPage)
          dispatch('searchWithParams')
        } else {
          commit(CHANGE_TABLE_LOADING, false)
        }

        return data
      },
      cbCatch: (e) => {
        commit(SHOW_RESULTS, false)
        commit(SHOW_SEARCH_ERROR, getResponseErrorMessage(e))
      },
    })
  },
  getFilters ({ commit, state, }) {
    return getData({ state, }, {
      endpoint: 'fields',
      cb: ({ data, }) => {
        commit(SET_FILTERS, data)
      },
    })
  },
  autocomplete ({ commit, state, }, { endpoint = 'autocompletions', q, field, }) {
    return getData({ state, }, {
      params: {
        q,
        field,
      },
      endpoint,
    }).then((res) => res ? res.data : [])
  },
  getResources ({ commit, state, }, resource) {
    return getData({ state, }, {
      endpoint: resource,
      params: { page: { size: 99999, }, },
    })
      .then((res) => res ? res.data.map(({ attributes, id, }) => ({
        ...attributes,
        id,
      })) : [])
  },
  exportFullFile ({ state, commit, }) {
    const url = `${exportFullFileUrl}golden-copies/publishes/lei2/${state.publishDate}.${state.exportFormat}`
    createDownloadLink(url)
    commit(TOGGLE_EXPORT_MODAL, false)
  },
  exportSearchResults ({ commit, getters, }, format) {
    if (format) {
      const params = getters.getParamsForExportSearch
      const url = `${exportSearchResultsUrl}lei-records.${format}?${params}`
      createDownloadLink(url)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/search/actions.js